import { TSchemaBuilder } from "@pages/ManualDocumentV2/core";
import * as Yup from "yup";
import {
  customerSchema,
  documentInfoSchema,
  itemsSchema,
  recurringSchema,
  taxesSchema,
  totalsSchema,
  uploadSchema,
  vendorSchema,
} from "../../../_shared/schemaHelpers";

export const franceRegularInvoiceSchema: TSchemaBuilder = (t) =>
  documentInfoSchema({
    t,
    documentClass: "Invoice",
    poErrorKey: "poNumber_is_required",
    poRequired: true,
    dueDateRequired: true,
    enforceDateOrder: true,
  })
    .concat(customerSchema(t))
    .concat(vendorSchema(t))
    .concat(itemsSchema(t))
    .concat(taxesSchema(t))
    .concat(totalsSchema(t))
    .concat(uploadSchema())
    .concat(recurringSchema())
    .shape(
      {
        poNumber: Yup.string().nullable().notRequired(),

        deliveryNote: Yup.string()
          .nullable()
          .notRequired(),

        customerPeppolSchemeId: Yup.string()
          .nullable()
          .when("customerPeppolParticipantId", {
            is: (val: any) => Boolean(val && val.trim() !== ""),
            then: (schema) => schema.required(t("scheme_id_required")),
            otherwise: (schema) => schema.notRequired(),
          }),

        customerPeppolParticipantId: Yup.string()
          .nullable()
          .when("customerPeppolSchemeId", {
            is: (val: any) => Boolean(val && val.trim() !== ""),
            then: (schema) => schema.required(t("participant_id_required")),
            otherwise: (schema) => schema.notRequired(),
          }),

        paymentTerms: Yup.string()
          .nullable()
          .required(t("payment_terms_is_required")),

        vendorPeppolInboxCountry: Yup.string()
          .transform((value) => (!value ? undefined : value))
          .nullable()
          .notRequired(),

        vendorPeppolSchemeId: Yup.string()
          .transform((value) => (!value ? undefined : value))
          .nullable()
          .notRequired(),

        vendorPeppolParticipantId: Yup.string()
          .transform((value) => (!value ? undefined : value))
          .nullable()
          .notRequired(),
      },
      [["customerPeppolSchemeId", "customerPeppolParticipantId"]],
    ) as Yup.ObjectSchema<any>;
